import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";


import { CodeResponseDto } from "src/dtos/code/codeDto";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { MenuDto } from "src/dtos/menu/menuDto";
import { UserResponseDto } from "src/dtos/user/response/userResponseDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { BankAcctDto } from "src/dtos/bank/bankacctDto";
import { InspectPopupDto } from "src/dtos/inspect/inspectPopupDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { CompanyDto } from "src/dtos/company/companyDto";

type DtoUnion = CustomerResponseDto | ItemDto | OrganizationDto | EmployeeDto | MenuDto | UserResponseDto | CodeResponseDto | WorkPlaceDto | WareHouseDto | BankAcctDto  | InspectPopupDto | EquipmentDto | CompanyDto;

interface Props {

}

export const SearchTableContent = (props : Props) => {

	const { 
	 } = props;

	return {
	}
}



export function isCustomer(item: DtoUnion): item is CustomerResponseDto {
	return 'customCd' in item && 'customNm' in item;
}
export function isItem(item: DtoUnion): item is ItemDto {
	return 'itemCd' in item && 'itemNm' in item;
}
export function isOrg(item: DtoUnion): item is OrganizationDto {
	return 'orgCd' in item && 'orgNm' in item;
}
export function isEmployee(item: DtoUnion): item is EmployeeDto {
	return 'empNo' in item && 'empNm' in item && 'compCd' in item && !('userId' in item);
}
export function isUser(item: DtoUnion): item is UserResponseDto {
	return 'userId' in item && 'userNm' in item && 'empNo' in item;
}
export function isMenu(item: DtoUnion): item is MenuDto {
	return 'menuCd' in item && 'menuNm' in item;
}
export function isMenuAuth(item: DtoUnion): item is CodeResponseDto {
	return 'codeNm' in item;
}
export function isWorkplace(item: DtoUnion): item is WorkPlaceDto {
	return 'workplaceCd' in item && 'workplaceNm' in item;
}
export function isWarehouse(item: DtoUnion): item is WareHouseDto {
	return 'warehouseCd' in item && 'warehouseNm' in item;
}
export function isBankacct(item: DtoUnion): item is BankAcctDto {
	return 'bankAcctCd' in item && 'bankAcctNm' in item;
}
export function isInspect(item: DtoUnion): item is InspectPopupDto {
	return 'inspectCd' in item && 'inspectNm' in item;
}
export function isEquipment(item: DtoUnion): item is EquipmentDto {
	return 'equipmentCd' in item && 'equipmentNm' in item;
}
export function isCompany(item: DtoUnion): item is CompanyDto {
	return 'compCd' in item && 'compNm' in item;
}

export function getRowClassRules(dto: DtoUnion) {
	let key: string | null = null;
	let value: string | null = null;

	if (dto) {
		if (isCustomer(dto)) {
			key = 'customCd';
			value = dto.customCd;
		} else if (isItem(dto)) {
			key = 'itemCd';
			value = dto.itemCd;
		} else if (isOrg(dto)) {
			key = 'orgCd';
			value = dto.orgCd;
		} else if (isEmployee(dto)) {
			key = 'empNo';
			value = dto.empNo;
		} else if (isUser(dto)) {
			key = 'userId';
			value = dto.userId;
		} else if (isWorkplace(dto)) {
			key = 'workplaceCd';
			value = dto.workplaceCd;
		} else if (isWarehouse(dto)) {
			key = 'warehouseCd';
			value = dto.warehouseCd;
		} else if (isBankacct(dto)) {
			key = 'bankAcctCd';
			value = dto.bankAcctCd;
		} else if (isEquipment(dto)) {
			key = 'equipmentCd';
			value = dto.equipmentCd;
		} else if (isInspect(dto)) {
			key = 'inspectCd';
			value = dto.inspectCd;
		} else if (isCompany(dto)) {
			key = 'compCd';
			value = dto.compCd;
		}
	}

	return {
		// 'selected' 클래스: 현재 행이 선택된 dto와 일치할 때 적용됩니다.
		'selected': (params: any) => {
			return !!(key && params.data && params.data[key] === value);
		},
		// 'hover' 클래스: 현재 행이 선택된 행이 아닐 때 적용됩니다.
		'hover': (params: any) => {
			if (key && params.data) {
				return params.data[key] !== value;
			}
			return true; // 선택된 항목이 없으면 모든 행에 hover가 가능합니다.
		}
	};
}